import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    title: 'py-1 uppercase',
    link: 'block px-4 py-2 duration'
  }
} satisfies CMSConfig['megaMenuL2Mobile']
